module.exports = __webpack_public_path__ + "img/Beneficio_2.63023d15.webp";